<template>
  <section class="photo-gallery">
    <transition name="move-fade" appear="">
      <h2>Event Highlights</h2>
    </transition>

    <div class="event-cards-grid load-hidden">
      <EventCard
        v-for="(event, idx) in sortedEvents"
        :key="idx"
        :event="event"
        @select="openModal"
      />
    </div>

    <Transition name="modal-fade">
      <PhotoModal
        :event="selectedEvent"
        v-if="selectedEvent"
        @close="selectedEvent = null"
        @open-photo="openPhotoViewer"
      />
    </Transition>

    <transition name="zoom-move-fade" appear>
      <PhotoViewer
        :photo="selectedPhoto"
        v-if="selectedPhoto"
        @close="selectedPhoto = null"
      />
    </transition>
  </section>
  <section class="video-gallery" v-if="isChecked">
    <transition name="move-fade" appear="">
      <h2>VideoClips</h2>
    </transition>
  </section>
</template>

<script>
import EventCard from './EventCard.vue';
import PhotoModal from './PhotoModal.vue';
import PhotoViewer from './PhotoViewer.vue';
import eventsRaw from '@/assets/data/events.json';
import ScrollReveal from 'scrollreveal';

export default {
  name: 'PhotoGallery',
  components: {
    EventCard,
    PhotoModal,
    PhotoViewer,
  },
  mounted() {
    this.$nextTick(() => {
      setTimeout(() => {
        const sr = ScrollReveal({
          origin: 'bottom',
          distance: '20px',
          duration: 700,
          easing: 'ease-out',
          cleanup: true,
          scale: 0.95,
        });

        sr.reveal('.event-cards-grid > *', {
          interval: 50,
        });
      }, 100);
    });
  },
  beforeUnmount() {
    ScrollReveal().destroy();
  },
  data() {
    return {
      events: [],
      selectedEvent: null,
      selectedPhoto: null,
      mediaType: 'photos',
    };
  },
  computed: {
    sortedEvents() {
      return this.events
        .slice()
        .sort((a, b) => new Date(b.date) - new Date(a.date));
    },
  },
  created() {
    this.events = eventsRaw.map((event) => ({
      ...event,
      photos: this.getPhotoList(
        `/media/photos/events/${event.photoFolder}/thumbnails`,
        event.photoCount
      ),
    }));
  },
  methods: {
    getPhotoList(path, count) {
      const list = [];
      for (let i = 1; i <= count; i++) {
        list.push(`${path}/${i}.webp`);
      }
      return list;
    },
    openModal(event) {
      this.selectedEvent = event;
    },
    openPhotoViewer(photo) {
      this.selectedPhoto = photo;
    },
  },
};
</script>

<style scoped>
.photo-gallery {
  padding: 2rem;
  padding-top: 0;
  color: #eee;
  text-align: center;
}

.event-cards-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  gap: 1.5rem;
  justify-items: center;
}

h2 {
  font-size: 2.5rem;
  margin-bottom: 2rem;
  color: #2c3e50;
  margin-top: 0;
}

/* Fade transition */
.modal-fade-enter-active,
.modal-fade-leave-active {
  transition: all 0.5s ease;
}

.modal-fade-enter-from,
.modal-fade-leave-to {
  opacity: 0;
  transform: scale(0.95);
}

.modal-fade-enter-to,
.modal-fade-leave-from {
  opacity: 1;
  transform: scale(1);
}

/* Zoom + Move + Fade Transition */
.zoom-move-fade-enter-active,
.zoom-move-fade-leave-active {
  transition: all 0.45s ease;
}

.zoom-move-fade-enter-from {
  opacity: 0;
  transform: scale(0.9) translateY(30px);
}

.zoom-move-fade-enter-to {
  opacity: 1;
  transform: scale(1) translateY(0);
}

.zoom-move-fade-leave-from {
  opacity: 1;
  transform: scale(1) translateY(0);
}

.zoom-move-fade-leave-to {
  opacity: 0;
  transform: scale(0.9) translateY(30px);
}

/* Move + Fade Transition */
.move-fade-enter-active,
.move-fade-leave-active {
  transition: all 0.45s ease;
}

.move-fade-enter-from {
  opacity: 0;
  transform: translateY(-20px);
}

.move-fade-enter-to {
  opacity: 1;
  transform: translateY(0);
}

.move-fade-leave-from {
  opacity: 1;
  transform: translateY(0);
}

.move-fade-leave-to {
  opacity: 0;
  transform: translateY(-20px);
}
</style>
